<router-outlet></router-outlet>
<div class="loader-container" *ngIf="mainAppService.isLoading">
    <app-loader></app-loader>
</div>
<div style="color: white;">v2.0</div>
<div class="ld-tag">
    <div class="footer-bottom">
        <div class="container">
            <div class="row align-items-center">
                <div class="bottom-text">
                    <div class="cb">
                        <span class="cby">BY </span> <a href="https://lditsolutions.com/" class="text-[16px] text-white hover:text-gray-400 duration-500 ease-in-out"><img src="assets/images/lditlogo.png" class="inline" style="height: 14px;"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>